
import React from 'react'
import icon from './svgs/goto.svg'
import { BaseIcon } from './_base'

export const GotoIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
